import { useEffect, useState } from "react";

import { getAccountingAccess } from "../../api/accounting";
import { useAuth } from "../../context/AuthContext";
import SalonBusinessCpaAccessRequired from "./SalonBusinessCpaAccessRequired";

export default function RequireAccountingAccess({ children }) {
  const { token } = useAuth();
  const [loading, setLoading] = useState(true);
  const [access, setAccess] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!token) return;
    let active = true;
    setLoading(true);
    setError("");
    getAccountingAccess(token)
      .then((data) => {
        if (active) setAccess(data);
      })
      .catch((err) => {
        if (active) {
          setError(
            err?.response?.data?.detail || "Unable to load SalonBusinessCPA access."
          );
        }
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [token]);

  if (loading) {
    return (
      <main className="flex min-h-screen items-center justify-center bg-[#f8f6f4] text-sm text-slate-500">
        Loading SalonBusinessCPA...
      </main>
    );
  }

  if (error) {
    return (
      <main className="min-h-screen bg-[#f8f6f4] px-5 py-10 text-slate-950">
        <div className="mx-auto max-w-3xl rounded-3xl border border-rose-200 bg-rose-50 p-5 text-sm text-rose-700">
          {error}
        </div>
      </main>
    );
  }

  if (!access?.eligible) {
    return <SalonBusinessCpaAccessRequired access={access} />;
  }

  return children;
}
